// extracted by mini-css-extract-plugin
export default {"DepartmentButton":"loadingDepartmentButton_DepartmentButton__NIqqj","Active":"loadingDepartmentButton_Active__XBOiL"};